const React = require('react');

const Content = require('../common/Content.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region DATE

function TermDate(props) {
    const data = props.data || {};
    return <Content.Value {...props} value={data.TermDate} />;
}
const TypeConfigTermDate = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style
    }
};

// #endregion DATE

// #region META

function _Meta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const MetaComponent = Content.withLabelTokenParsing(_Meta, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.TermDate)) {
                replaceString = Token.getReplacementString(data.TermDate, options);
            }
            break;
        case Token.Terms:
            if (!Utilities.isNullOrWhitespace(data.Terms)) {
                replaceString = Token.cleanTokenValueForReplacement(data.Terms, options);
            }
            break;
        case Token.Title:
            if (!Utilities.isNullOrWhitespace(data.Title)) {
                replaceString = Token.getReplacementString(data.Title, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});

const TokensMeta = () => {
    return [
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Term Date', Token.Date),
        Token.getWrappedTokenConfig('Terms', Token.Terms)
    ]
};
const TypeConfigMeta = {
    defaultDesign: () => `${Utilities.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, token: Token.Title })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })}`,
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(1),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: Content.TypeConfig.labelValue.panelV2.label,
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (defaultDesign) => Content.TypeConfig.labelValue.panelV2.value(defaultDesign || TypeConfigMeta.defaultDesign())
    }
};

// #endregion META

// #region TERMS

function Terms(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.Terms)) {
        return null;
    }
    const content = [<div key="0" dangerouslySetInnerHTML={{ __html: data.Terms }} />];
    return <Content.Value {...props} value={content} />;
}
const TypeConfigTerms = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style
    }
};

// #endregion TERMS

// #region TITLE

function Title(props) {
    const data = props.data || {};
    return <Content.Value {...props} value={data.Title} />;
}
const TypeConfigTitle = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.block({}); },
        style: Content.TypeConfig.value.panel.style
    }
};

// #endregion TITLE

module.exports = {
    TermDate: {
        Component: TermDate,
        TypeConfig: TypeConfigTermDate
    },
    Terms: {
        Component: Terms,
        TypeConfig: TypeConfigTerms
    },
    Title: {
        Component: Title,
        TypeConfig: TypeConfigTitle
    },

    V2: {
        Component: MetaComponent,
        Tokens: TokensMeta,
        TypeConfig: TypeConfigMeta
    }
};